import { useFeatureCtx } from 'containers/features/FeatureContext'
import React from 'react'
import ScreenLoading from './ScreenLoading'

type FeatureOpt =
  "can_add_accounts" |
  "can_add_users" |
  "has_database_access"  |
  "integrations" |
  "competition" |
  "clusters" |
  "pagespeed" |
  "marketplace" |
  "destination_configuration" |
  "bookmarks" |
  "embed" |
  "reports" |
  "developers_tab" |
  "destinations_tab" |
  "demo" |
  "custom_reports"

interface IFeatureProps {
  children: any
  switchComponent: React.ReactElement
  feature: FeatureOpt | ((features: any) => boolean)
}

const Feature: React.FC<IFeatureProps> = ({
  feature,
  switchComponent,
  children,
}) => {
  const featureCtx = useFeatureCtx()

  // Handle null context gracefully
  if (!featureCtx) {
    return switchComponent
  }

  const { features } = featureCtx

  // If features haven't loaded yet, hide the feature by default
  if (features === null) {
    return switchComponent
  }

  if (typeof feature === 'function') {
    return feature(features) ? <>{children}</> : switchComponent
  }

  if (features instanceof Object && features[feature]) {
    return <>{children}</>
  } else {
    return switchComponent
  }
}

export default Feature
